<template>
    <svg
      :width="size"
      :height="size"
      viewBox="0 0 9 13"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.85904 8.08477H0.539858C0.325358 8.08477 0.168857 7.99195 0.0703572 7.80633C-0.0282679 7.62083 -0.0232051 7.4372 0.0855449 7.25545L4.47436 0.297891C4.55036 0.156516 4.66048 0.0660779 4.80473 0.026578C4.94886 -0.012797 5.09304 -0.00842173 5.23729 0.0397032C5.38154 0.0877031 5.49598 0.175641 5.58061 0.303516C5.66523 0.431391 5.69742 0.573704 5.67717 0.730454L5.15086 5.23477H7.70517C7.93492 5.23477 8.09836 5.33577 8.19548 5.53777C8.29261 5.73964 8.27292 5.93145 8.13642 6.1132L3.32198 12.2645C3.22586 12.3809 3.10879 12.4581 2.97079 12.4961C2.83279 12.534 2.69554 12.5188 2.55904 12.4505C2.42254 12.3823 2.31942 12.2842 2.24967 12.1563C2.17992 12.0285 2.16142 11.8924 2.19417 11.7481L2.85904 8.08477Z"
        :fill="fillColor"
      />
      <path
        d="M3.42004 10.541L6.85129 6.20977H4.05755L4.54504 2.06602L1.30129 7.10977H4.03879L3.42004 10.541ZM2.85904 8.08477H0.539857C0.325357 8.08477 0.168857 7.99195 0.0703573 7.80633C-0.0282677 7.62083 -0.0232053 7.4372 0.0855447 7.25545L4.47436 0.297891C4.55036 0.156516 4.66048 0.066078 4.80473 0.026578C4.94886 -0.012797 5.09304 -0.00842175 5.23729 0.0397033C5.38154 0.0877033 5.49598 0.175641 5.58061 0.303516C5.66523 0.431391 5.69742 0.573704 5.67717 0.730454L5.15086 5.23477H7.70517C7.93492 5.23477 8.09836 5.33577 8.19548 5.53777C8.29261 5.73964 8.27292 5.93145 8.13642 6.1132L3.32198 12.2645C3.22586 12.3809 3.1088 12.4581 2.9708 12.4961C2.8328 12.534 2.69554 12.5188 2.55904 12.4505C2.42254 12.3823 2.31942 12.2842 2.24967 12.1563C2.17992 12.0285 2.16142 11.8924 2.19417 11.7481L2.85904 8.08477Z"
        :fill="strokeColor"
      />
    </svg>
  </template>
  
  <script>
  export default {
    name: "Bolt",
    props: {
      fillColor: {
        type: String,
        default: "transparent", // Cor padrão
      },
      strokeColor: {
        type: String,
        default: "#696969", // Cor padrão
      },
      size: {
        type: [Number, String],
        default: 24, // Tamanho padrão
      },
    },
  };
  </script>
  